import { render } from "./QuickpayPaymentOverviewDescription.vue?vue&type=template&id=d59956bc&scoped=true"
import script from "./QuickpayPaymentOverviewDescription.vue?vue&type=script&lang=js"
export * from "./QuickpayPaymentOverviewDescription.vue?vue&type=script&lang=js"

import "./QuickpayPaymentOverviewDescription.vue?vue&type=style&index=0&id=d59956bc&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d59956bc"]])

export default __exports__